import React from 'react';
import Asir from '../asets/AnkurSir.jpg';
import Pmam from '../asets/PmamP.png';
import Bmam from '../asets/BmamB.png';

import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardImage,
  MDBRow,
  MDBCol
} from 'mdb-react-ui-kit';

export const Cardsir = () => {
  return (
    <MDBRow
      style={{
        background: 'linear-gradient(135deg, #e0f7fa, #b2ebf2)',
        padding: '3rem',
        gap: '1.5rem',
        justifyContent: 'center',
      }}
      className="row-cols-1 row-cols-md-3"
    >
      {[{
        name: 'Director - Mrs. Asha Jain',
        img: Bmam,
        desc: 'Dedicated to excellence in education and leadership.',
        borderColor: '#ff8000'
      }, {
        name: 'Principal - Mr. Ankur Jain',
        img: Asir,
        desc: 'Inspiring students with innovative teaching methods.',
        borderColor: '#007bff'
      }, {
        name: 'Co-Director - Mrs. Purvi Jain',
        img: Pmam,
        desc: 'Committed to fostering creativity and collaboration.',
        borderColor: '#28a745'
      }].map((person, index) => (
        <MDBCol key={index}>
          <MDBCard
            style={{
              background: 'rgba(255, 255, 255, 0.9)',
              backdropFilter: 'blur(10px)',
              border: 'none',
              borderRadius: '20px',
              boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.3)',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            }}
            className="hover-card"
          >
            <MDBCardImage
              src={person.img}
              position="top"
              alt="..."
              style={{
                width: '150px',
                height: '150px',
                borderRadius: '50%',
                margin: '1.5rem auto',
                objectFit: 'cover',
                border: `5px solid ${person.borderColor}`,
                transition: 'transform 0.5s ease, border-color 0.5s ease',
              }}
              className="hover-image"
            />
            <MDBCardBody style={{ textAlign: 'center' }}>
              <MDBCardTitle
                style={{
                  fontWeight: '700',
                  fontSize: '1.5rem',
                  color: '#343a40',
                  marginBottom: '0.5rem',
                  transition: 'color 0.3s ease',
                }}
                className="hover-title"
              >
                {person.name}
              </MDBCardTitle>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#6c757d',
                  marginBottom: '1rem',
                }}
              >
                {person.desc}
              </p>
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      ))}
    </MDBRow>
  );
};
